function getBaseViews() {
  return null;
}
export {
  getBaseViews
};
//# sourceMappingURL=getBaseViews.js.map
